import { mobile, tablet } from "../../../mediaQueries"

const styles = theme => ({
    root: {
        textAlign: 'center'
    },
    h1: {
        color: props => props.textColor,
        margin: 0,
        fontSize: '5.625rem',
        fontFamily: 'Playfair Display',
        fontWeight: '400',
        letterSpacing: '0.06em',
        [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
            fontSize: '4rem'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
            fontSize: '50px'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 350)]: {
            fontSize: '35px'
        }
    },
    h2: {
        color: props => props.textColor,
        margin: 0,
        marginTop: '23px',
        fontSize: '24px',
        lineHeight: '31.2px',
        letterSpacing: '0.05em',
        [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
            fontSize: '1.4rem'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
            fontSize: '18px'
        },
        fontFamily: 'Aktiv Grotesk',
        fontWeight: 400
    }
})

export default styles